import ErrorBoundary from './ErrorBoundary';

export * from './PageErrorBoundary';
export * from './PublicPageErrorBoundary';
export default ErrorBoundary;
